import { getParameter } from '../utilities/url';

import { getCell, setCell, getSpid } from '../session-storage';

export default [
    {
        name: 'Force Cell Code from Source Code Campaign',
        condition: () => true,
        action: (fields) => {
            const spid = getSpid();

            // Check if we have SPID fields and an active campaign
            if (!fields?.spid || !spid?.campaignId || spid.campaignId === 'none') {
                return false;
            }

            const { defaultSet, campaignSets } = fields.spid;
            // Ensure campaignSets is always an array to prevent spread operator errors
            const safeCampaignSets = Array.isArray(campaignSets) ? campaignSets : [];
            const allCampaignSets = [defaultSet, ...safeCampaignSets];

            // Find the active campaign set
            const activeCampaignSet = allCampaignSets.find(
                (campaignSet) => campaignSet?.campaignId === spid.campaignId
            );

            // Check if govern is enabled and the active campaign set has a forceCellCode value
            if (activeCampaignSet?.govern && activeCampaignSet?.forceCellCode && activeCampaignSet.forceCellCode.trim() !== '') {
                setCell({
                    value: activeCampaignSet.forceCellCode.trim(),
                    type: 'forced'
                });

                return true;
            }

            return false;
        }
    },
    {
        name: 'Standard CELL Code Test (Parameter CELL)',
        condition: () => getParameter('cellcode').value !== null,
        action: () => {
            const cellValue = getParameter('cellcode').value;

            if (!/^[A-Z0-9]{6}$/i.test(cellValue)) {
                return false;
            }

            setCell({
                value: cellValue,
                type: 'standard'
            });

            return true;
        }
    },
    {
        name: 'Standard CELL Code (Session Persistence)',
        condition: () => getCell().type === 'standard',
        action: () => /^[A-Z0-9]{6}$/i.test(getCell().value)
    },
    {
        name: 'Search Referral Test',
        condition: () => document.referrer,
        action: (fields) => {
            const parser = document.createElement('a');
            parser.href = document.referrer;
            const referrer = parser.hostname.replace('www.', '');
            const referrersToCheck = ['google.com', 'yahoo.com', 'bing.com', 'ask.com', 'aol.com'];

            if (referrersToCheck.includes(referrer)) {
                const storage = {
                    value: fields.cell.naturalSearch,
                    type: 'natural_search'
                };

                setCell(storage);

                return true;
            }

            return false;
        }
    },
    {
        name: 'Default CELL Code Test',
        condition: () => true,
        action: (fields) => {
            const pageDefaultCellType = fields.page.defaultCellType;

            setCell({
                value:
                    pageDefaultCellType === 'custom'
                        ? fields.page.customDefaultCellCode
                        : fields.cell.default[pageDefaultCellType],
                type: pageDefaultCellType === 'custom' ? pageDefaultCellType : pageDefaultCellType
            });

            return true;
        }
    }
];
